import { withAsyncPaginate } from "react-select-async-paginate";

import Select from "./Select";

// This wraps our own Select component so that a select loading its options page by page,
// as the visitor scrolls through them, still carries the accessibility and translation
// configuration that every select of the app shares.
//
const AsyncPaginateSelect = withAsyncPaginate(Select);

export default AsyncPaginateSelect;
